import { api } from '../../../../services/api';
import { GetBillingInformationResponse, ServiceBaseConfig } from './Interface';

export class BillingPaymentService {
  public static async getBillingInformation(
    config: ServiceBaseConfig,
    currentPage: number,
    sortBy: string,
    sortDirection: string,
    filters?: string | null,
  ): Promise<GetBillingInformationResponse> {
    const { data } = await api.get(
      `/companies/payments?${filters}order${sortBy}=${sortDirection}&page=${currentPage}`,
      config
    );
    return data;
  }
}